import { useEffect, useRef } from "react";
import SVG from "../SVG"
import useElementEdgeCenters from "../../hooks/useElementEdgeCenters";

export default function HeroGuide({title, h1, h2, h3, icon1, icon2, icon3, text1, text2, text3}) {
  
  function formatText(str) {
  if (!str) return null;
  return str.split("||").map((part, i) => (
    <span key={i}>
      {part}
      {i < str.split("||").length - 1 && <br />}
    </span>
  ));
}

  const divOneBoxRef = useRef();
  const edgesOne = useElementEdgeCenters(divOneBoxRef);
  const divTwoBoxRef = useRef();
  const edgesTwo = useElementEdgeCenters(divTwoBoxRef);


  useEffect(() => console.log(edgesTwo))
  
  return (
    <div className=" w-full p-5 rounded-2xl flex flex-col bg-zi-bg2-light dark:bg-zi-bg2-dark">
      <h3 className="font-medium text-lg text-zi-text-light dark:text-zi-text-dark">
        {title}
      </h3>
      <div className="w-full pt-5 flex items-start gap-5 overflow-auto lg:overflow-visible">
        <div className="relative lg:w-full flex flex-col gap-2.5 justify-start items-center">
          <div className="absolute -left-[calc(50%-24px)] top-[24px] -translate-y-full w-[calc(100%-68px)] 2xl:hidden" >
            <SVG name="line" classname="" />
          </div>
          <div ref={divOneBoxRef} className="size-10 lg:size-12 rounded-full bg-zi-radial-gradient-blue flex justify-center items-center">
            <SVG name={icon1} classname="stroke-zi-text-dark size-5 lg:size-6"/>
          </div>
          <h4 className="font-medium text-zi-text-light dark:text-zi-text-dark">
            {h1}
          </h4>
          <p className="text-zi-text-light/50 dark:text-zi-text-dark/50 text-center text-nowrap">
            {formatText(text1)}
          </p>
        </div>
        
        <div className="relative lg:w-full flex flex-col gap-2.5 justify-start items-center">
          <div className="absolute -left-[calc(50%-24px)] top-[24px] w-[calc(100%-68px)] 2xl:hidden" >
            <SVG name="lineMirrored" classname="" />
          </div>
          <div ref={divTwoBoxRef}  className="size-10 lg:size-12 rounded-full bg-zi-radial-gradient-blue flex justify-center items-center">
            <SVG name={icon2} classname="stroke-zi-text-dark size-5 lg:size-6"/>
          </div>
          <h4 className="font-medium text-zi-text-light dark:text-zi-text-dark">
            {h2}
          </h4>
          <p className="text-zi-text-light/50 dark:text-zi-text-dark/50 text-center text-nowrap">
            {formatText(text2)}
          </p>
        </div>

        <div className="lg:w-full flex flex-col gap-2.5 justify-start items-center">
          <div className="size-10 lg:size-12 rounded-full bg-zi-radial-gradient-blue flex justify-center items-center">
            <SVG name={icon3} classname="stroke-zi-text-dark size-5 lg:size-6"/>
          </div>
          <h4 className="font-medium text-zi-text-light dark:text-zi-text-dark">
            {h3}
          </h4>
          <p className="text-zi-text-light/50 dark:text-zi-text-dark/50 text-center text-nowrap">
            {formatText(text3)}
          </p>
        </div>
      </div>
    </div>
  )
}